import { Typography as TypographyMui } from "@mui/material";

const Typography = ({
  children,
  className,
  classes,
  color,
  gutterBottom,
  noWrap,
  style,
  paragraph,
  sx,
  align,
  variant,
  variantMapping,
  onClick,
}) => {
  return (
    <TypographyMui
      className={className}
      sx={sx}
      color={color}
      style={style}
      classes={classes}
      align={align}
      gutterBottom={gutterBottom}
      noWrap={noWrap}
      paragraph={paragraph}
      variant={variant}
      variantMapping={variantMapping}
      onClick={onClick}
    >
      {children}
    </TypographyMui>
  );
};

export default Typography;
